<script>
import baseMixin from '@/mixins/baseMixin'
import { mapActions } from 'vuex'
import JsonDataRenderer from '@/components/general/json-data-renderer.vue'
import BullhornErrorBlock from './bullhorn-error-block.vue'

export default {
  name: 'TheLegacyBullhornDataContainer',
  components: {
    BullhornErrorBlock,
    JsonDataRenderer,
  },
  mixins: [baseMixin],
  props: {
    candidateId: {
      type: Number,
      required: true,
    },
  },
  data: () => {
    return {
      rawData: null,
      loading: false,
      error: null,
    }
  },

  async created() {
    await this.loadBullhornData()
  },
  methods: {
    ...mapActions('candidate', ['getBullhornData']),
    async loadBullhornData() {
      this.error = null

      this.loading = true

      const { isSuccess, data, errors } = await this.getBullhornData(
        this.candidateId
      )

      this.loading = false

      if (!isSuccess) {
        this.error = {
          code: errors?.data?.code || 'unknown_error',
          status: errors?.status,
          message: errors?.data?.message,
        } || {
          code: 'unknown_error',
          status: null,
          message: '',
        }
        return
      }

      this.rawData = data
    },
  },
}
</script>

<template>
  <div v-if="loading" class="h-100 d-flex justify-center align-center">
    <v-progress-circular
      :size="120"
      :width="7"
      color="primary"
      indeterminate
    ></v-progress-circular>
  </div>

  <BullhornErrorBlock
    v-else-if="error"
    :error="error"
    :candidate-id="candidateId"
    @retry="loadBullhornData"
  />

  <v-card v-else :class="{ 'custom-elevation': isEmbedded }" flat>
    <JsonDataRenderer :json="rawData" />
  </v-card>
</template>
